export const path =
  'M20.853 4c-2.095 0-4.173 1.116-5.312 2.03a.943.943 0 01-1.182 0C13.22 5.116 11.142 4 9.047 4 5.32 4 2.3 6.945 2.3 10.577c0 6.476 9.688 13.582 12.108 15.255a.958.958 0 001.084 0c2.42-1.673 12.108-8.78 12.108-15.255C27.6 6.945 24.58 4 20.853 4';

export default (props) => (
  <svg {...props} viewBox="0 0 30 30" aria-hidden="true" focusable="false">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h30v30H0z" />
      <path d={path} fill="currentColor" fillRule="nonzero" />
    </g>
  </svg>
);
